import React from 'react';

import { MonthConsumption } from 'entities/MonthConsumption';
import { Notice } from './setup-wizard.styles';

const MONTHS = [
  'jan',
  'fev',
  'mar',
  'abr',
  'mai',
  'jun',
  'jul',
  'ago',
  'set',
  'out',
  'nov',
  'dez',
];

const label = (rm: string) => {
  const [y, m] = rm.split('_');
  return `${MONTHS[Number(m) - 1] ?? m}/${y}`;
};

interface InvoiceHistoryNoticeProps {
  refMonth: string;
  history?: MonthConsumption[];
}

/**
 * "12 meses de histórico encontrados na fatura — uma fatura basta para começar"
 * (P2 do assistente, out/2026). O checklist antigo pedia 3 a 12 faturas, mas a
 * fatura já traz o histórico impresso de até 12 meses. Conta os meses do
 * histórico com consumo + o próprio mês da fatura.
 */
export const InvoiceHistoryNotice = ({
  refMonth,
  history = [],
}: InvoiceHistoryNoticeProps) => {
  const months = Array.from(
    new Set([
      refMonth,
      ...history.filter((h) => (h.value ?? 0) > 0).map((h) => h.refMonth),
    ])
  ).sort();
  if (months.length <= 1) return null;

  return (
    <Notice tone="success">
      <p>
        <b>{months.length} meses de histórico</b> encontrados na fatura (
        {label(months[0])} a {label(months[months.length - 1])}). Uma fatura
        basta para começar.
      </p>
    </Notice>
  );
};
